import { render } from "./HeaderComponentDevicesInventory.vue?vue&type=template&id=05bb8355"
import script from "./HeaderComponentDevicesInventory.vue?vue&type=script&lang=js"
export * from "./HeaderComponentDevicesInventory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__